import React, { useState, useEffect } from 'react';
import { Form, Input, Row, Col, Button, Checkbox } from 'antd';
import { StudentEditModal } from 'components/molecules';
import { usePopupManager } from 'react-popup-manager';

interface FormItemProps {
  info: LectureInfoDto|undefined;
  type: string;
  nonAttendList?: NonAttendInfoDto[];
  refetch?: ()=> void;
  onMemoUpdate: (params: B2cInfoSaveReqDto) => void;
}

const LectureInfoForm = ({info, type, nonAttendList, refetch, onMemoUpdate}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const [viewNonAttendList, setViewNonAttendList] = useState<boolean>(true);    
  const { open } = usePopupManager();
  /* ======================================================
  * hooks
  * ====================================================== */

  /* ======================================================
  * events
  * ====================================================== */  

  const onSubmit = (e) => {
    if (info)
      onMemoUpdate({id: info.id, memo: e.memo, memo1: e.memo1, memo2: e.memo2, memo3: e.memo3, memo4: e.memo4})
  };

  useEffect(() => {
    if (!!info)
    form.setFieldsValue({
        memo: info.memo || '',
        memo1: info.memo1 || '',
        memo2: info.memo2 || '',
        memo3: info.memo3 || '',
        memo4: info.memo4 || '',
    });
}, [info]);  
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <div className={'custom-modal'}>
      <Form
        form={form}
        name="ProjectInfo"
        layout="horizontal"  
        labelCol={{ flex: '120px' }}
        onFinish={onSubmit}
        style={{width:'100%'}}
        autoComplete="off"
      >
        <Row>
            <Col span={12}>
            <Form.Item label={'과정명'}>
                <label>{info?.lecture_title}</label>                  
            </Form.Item> 
            </Col> 
            <Col span={12}> 
            <Form.Item label={type==='pml'?'진단기간':'기간'}>
                <label>{info?.start_date} ~ {info?.end_date}</label>                  
            </Form.Item>   
            </Col>            
        </Row> 
        {(type !== 'pml') && (
        <Row>
          <Col span={12}>
            <Form.Item label={'장소'}>
                <label>{info?.lecture_place}</label>                  
            </Form.Item>   
          </Col> 
          <Col span={12}> 
            <Form.Item label={'최대교육인원'}>
                <label>{info?.student_max}</label>                  
            </Form.Item>   
          </Col>            
      </Row>           

        )}
        {(type !== 'seminar') && (
        <Row>
            <Col span={12}>
            <Form.Item label={'총매출액'}>
                <label>{info?.max_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+' 원 '} {'(vat포함: '+(info?info.max_price*1.1:0).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+')'}</label>                  
            </Form.Item> 
            </Col> 
            <Col span={12}> 
            <Form.Item label={type==='pml'?'진단비':'단가'}>
                <label>{info?.lecture_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</label>                  
            </Form.Item>   
            </Col>            
        </Row> 
        )}
        <Form.Item name='memo' label={'메모'}>
          <TextArea rows={3} placeholder='메모를 입력하세요'/>   
        </Form.Item>  
        {!!nonAttendList && (
        <>  
          <Form.Item label={'보강명단'}>
            <Checkbox defaultChecked={viewNonAttendList} onChange={(e)=>setViewNonAttendList(e.target.checked)}>보강명단보기</Checkbox> 
            {viewNonAttendList && nonAttendList.map(schedule => {
              return (
                <Row key={schedule.schedule_srl} style={{borderTopWidth: '1px', borderTopColor:'#ccc', borderTopStyle:'solid'}}>
                  <Col span={4}>
                    {schedule.schedule_time}
                  </Col>
                  <Col span={2}>
                    {schedule.lecturer}
                  </Col>                  
                  <Col span={4}>
                    {schedule.lecture_subject}
                  </Col> 
                  <Col span={14} style={{display:'flex', flexWrap:'wrap', columnGap:10, borderLeftWidth: '1px', borderLeftColor:'#ccc', borderLeftStyle:'solid', paddingLeft: 10, paddingRight: 10}}>
                  {!!schedule.studentList && schedule.studentList.map(student => {
                    return (
                      <a 
                        key={student.id} 
                        style={{display:'flex'}}
                        onClick={() => {
                          if (!!refetch && !!info) {
                            open(StudentEditModal, { 
                              id: student.id,
                              group: type,
                              lectureInfo: info,
                              refetch: refetch,
                              onClose: (isOk) => {
                                if (isOk) {   
                                  refetch();
                                };
                              },          
                            });                      
                          }
                        }}
                      >
                        <label style={{color:'black'}}>{student.name_kor} <label style={{color:'red'}}>({student.memo})</label></label>
                      </a>                      
                    )
                  })}
                  </Col>                           
                </Row>
              )
            })}                      
          </Form.Item> 
          <Button htmlType="submit"  type="primary" style={{margin:"10px 0px", float:"right"}}>{'메모저장'}</Button>
        </>
        )}
                                             
        
      </Form>
    </div>
    
  );
};

export default LectureInfoForm;
